import Country from "./Country";

const AddressConfig: Record<string, Country[]> = {
  vat_no: [Country.SPAIN, Country.ITALY],
  state_code: [Country.USA],
};

export default AddressConfig;
